module.exports = __webpack_public_path__ + "static/img/team-rule.7bc0ef1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleFestival/popup/team-rule.png
// module id = G9TZ
// module chunks = 1